<template lang="pug">
  .flooring
    FlooringRolls(v-if="sku === 'RG000_NEW'" :buy-request="buyRequest")
    FlooringTiles(v-else :buy-request="buyRequest" :sku="sku")
</template>
<script>
import FlooringRolls from './flooring-rolls.vue'
import FlooringTiles from './flooring-tiles.vue'

export default {
  components : { FlooringRolls, FlooringTiles },
  props      : {
    buyRequest: {
      type     : Object,
      required : true,
    },
    sku: {
      type     : String,
      required : true,
    },
  },
  data() {
    return {
      onScroll: null,
    }
  },
  mounted() {
    this.handleScroll()
  },
  beforeUnmount() {
    if (this.onScroll) {
      window.document.removeEventListener('scroll', this.onScroll)
      this.onScroll = null
    }
  },
  methods: {
    handleScroll() {
      let media = document.getElementById('pdp-media')

      // #pdp-media comes from ProductPage inside a Suspense boundary, so it can still
      // be absent when a scroll event fires - re-query and bail until it exists.
      this.onScroll = () => {
        if (!media) {
          media = document.getElementById('pdp-media')
          if (!media) return
        }
        const rect = media.getBoundingClientRect()
        if (rect.top <= 0) {
          media.classList.add('media-sticky')
        } else {
          media.classList.remove('media-sticky')
        }
      }

      window.document.addEventListener('scroll', this.onScroll)
    },
  },
}
</script>
<style lang="scss">
@include mobile {
  .media-sticky {
    position: sticky;
    top: 0;
    z-index: 2 !important;
    background: #f8f8f8;
  }
}
</style>
